import { Pipe, PipeTransform } from "@angular/core";
import { SmallGroupLessons, SmallGroupLessonType } from "src/app/core/models/small-group.model";

@Pipe({
  name: 'smallGroupLessonDisplay',
  standalone: true,
})
export class SmallGroupLessonDisplayPipe implements PipeTransform {
  transform(taskID: string) {
    const lesson = SmallGroupLessons.find(l => l.tasks.find(t => taskID.startsWith(t)));
    if (!lesson) {
      return "—";
    }

    switch (lesson.type) {
      case SmallGroupLessonType.COMPREHENSION:
        return "Engage, Read, Discuss / Comprehension";
      case SmallGroupLessonType.MORPHOLOGY_VOCABULARY:
        return "Syllable Focus (Morphemes)";
      case SmallGroupLessonType.DECODING_WORD_RECOGNITION:
        return "Decoding";
      case SmallGroupLessonType.SPELLING:
        return "Spelling";
      case SmallGroupLessonType.SPELLING_DEVELOPMENT:
        return "Spelling Development";
      case SmallGroupLessonType.SYLLABLE:
        return "Syllable Focus";
      case SmallGroupLessonType.PHRASING:
        return "Phrasing Fluency";
    }

    return "—";
  }
}
